/* @flow */

export const ActionTypes = {
    TRIAL_SWAP_MODAL_TOGGLED: 'TRIAL_SWAP_MODAL_TOGGLED',
    TRIAL_PLAN_CHANGED: 'TRIAL_PLAN_CHANGED',
};

type IsModalOpen = {type: 'TRIAL_SWAP_MODAL_TOGGLED', payload: boolean};
type PlanChange = {type: 'TRIAL_PLAN_CHANGED', payload: string};

export type TrialAction = IsModalOpen | PlanChange;

/*
 * Action creators
 *
 * These functions will be called by our app to create an action which can be dispatched.
 */
export const isModalOpen = (isOpen: boolean) => ({
    type: ActionTypes.TRIAL_SWAP_MODAL_TOGGLED,
    payload: isOpen,
});

export const handlePlanChange = (newPlanSku: string) => {
    return {
        type: ActionTypes.TRIAL_PLAN_CHANGED,
        payload: newPlanSku,
    };
};
